import React, { memo,useEffect,useState } from "react";
import {
  ZoomableGroup,
  ComposableMap,
  Geographies,
  Geography
} from "react-simple-maps";
import { scaleLinear } from "d3-scale";
import json from '../pages/features.json'


import axios from 'axios'


const Map = ({ setTooltipContent,setNone,mapType,handleOpen,setlistOfStud,setNumbStd }) => {

  const [data,setData]=useState({})


  const [map,setMap]=useState('')
  useEffect(() => {
    axios.get(process.env.REACT_APP_STUDENT_API+'/students/map?type='+mapType).then(map =>{
      
      
      setData(map.data.map_data)
      const d = map.data.map_data.find((s) => s.nationality === 'None');
      console.log(map.data);
      
      setNone(d.size)
      setNumbStd(map.data.stud_numb)
      const colorScale=scaleLinear()
      .domain([map.data.last, map.data.start])
      .range(["#ffedea", "#ff5233"])
      console.log(colorScale(d["size"]));
      
      setMap(<Geographies geography={json}>
            {({ geographies }) =>
              geographies.map((geo) =>{ 
                const d = map.data.map_data.find((s) => s.nationality === geo.id);
                
                return(
                  <Geography
                  className="country"
                  key={geo.rsmKey}
                  geography={geo}
                  stroke="#c54028ff"
                  fill={d ? colorScale(d["size"]) : "#ffedea"}
                  onMouseEnter={() => {
                    setTooltipContent(<><strong>{geo.properties.name} </strong>
                     <br/>Students: {d ?d["size"]:''}</>);
                  }}
                  onMouseLeave={() => {
                    setTooltipContent("");
                  }}
                  onClick={() => {
                    clicked(geo.id)
                  }}
                  style={{
                    hover: {
                      fill: "#F53",
                      outline: "none"
                    },
                    pressed: {
                      fill: "#E42",
                      outline: "none"
                    }
                  }}
                  />
                )})
              }
          </Geographies>)
    })
  },[mapType])

  const clicked =(code3)=>{
    axios.get(process.env.REACT_APP_STUDENT_API+'/students/map/single?type='+mapType+'&code3='+code3).then(map =>{
      setlistOfStud(map.data)
    }).then(()=>{
      handleOpen()

    })
  }

  return (
    <>
    {Object.keys(data).length>0?
      <>
      <ComposableMap
      style={{
        height:'700px'
      }}
      >
        <ZoomableGroup>
          {map}
        </ZoomableGroup>
      </ComposableMap>
    </>
    
    :''}
    </>
  );
};

export default memo(Map);
